import {useEffect, useRef, useState} from 'react'
import { fileSrc } from './fileUtils'
import { Styles } from './Select'

type SelectProps = {
  //meta?: FieldMetaProps<string>
  // label?: string
  // onSelect: (file: File) => void
  // disabled?: boolean
  // error?: boolean
  // acceptedTypes?: string []
  // maxSizeMB?: number
  label?: string
  onSelect: (file: File | null) => void
  disabled?: boolean
  error?: boolean
  acceptedTypes?: string[]
  maxSizeMB?: number
  blankImg?: string
  width?: number
  height?: number
  file?: File | string
}

export const SelectFile = (props: SelectProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [fileName, setFileName] = useState<string>('No file chosen')

  const [sizeError, setSizeError] = useState<string>('')

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

     const maxSizeBytes = (props.maxSizeMB || 5) * 1024 * 1024
    if (file.size > maxSizeBytes) {
      setSizeError(`File exceeds ${props.maxSizeMB || 5}MB limit`)
      props.onSelect(null)
      return
    }

    setSizeError('')
    props.onSelect(file)
    e.target.value = '' // reset file input
  }

  const handleClick = () => {
    if (!props.disabled) inputRef.current?.click()
  }
  type TypeKey = keyof typeof types
  const accept = props.acceptedTypes?.map((type) => types[type as TypeKey]).join(',')
  return (
    <>
      <Styles />
      <div className='file-wrapper'>
        <div
          className={`file-container ${props.disabled ? 'disabled' : ''} ${
            props.error || sizeError ? 'error' : ''
          }`}
          onClick={handleClick}
        >
          <span className='custom-button'>Choose File</span>
          <span className='file-name'>{fileName}</span>
          <input
            ref={inputRef}
            type='file'
            className='custom-file-input'
            accept={accept}
            onChange={handleFileChange}
            disabled={props.disabled}
          />
        </div>
        {sizeError && <div className='file-error'>{sizeError}</div>}
      </div>
    </>
  )
}

export const types = {
  allFiles: '*/*',
  images: 'image/*',
  pdf: 'application/pdf',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
} as const

export const docTypes = ['doc', 'docx', 'csv', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx'] as const

export const SelectImage = (props: SelectProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const [sizeError, setSizeError] = useState<string>('')

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const maxSizeBytes = (props.maxSizeMB || 5) * 1024 * 1024
    if (file.size > maxSizeBytes) {
      setSizeError(`Image exceeds ${props.maxSizeMB || 5}MB limit`)
      setPreviewUrl(null)
      return
    }

    setSizeError('')
    const url = URL.createObjectURL(file)
    setPreviewUrl(url)
    props.onSelect(file)
    e.target.value = ''
  }

  const handleRemoveImage = () => {
    setPreviewUrl(null)
    props.onSelect(null as any)
  }

  useEffect(() => {
    if (!props.file) {
      setPreviewUrl(null)
      return
    }

    if (typeof props.file === 'string') {
      setPreviewUrl(fileSrc(props.file))
    } else {
      const objectUrl = URL.createObjectURL(props.file)
      setPreviewUrl(objectUrl)

      return () => {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [props.file])

  type TypeKey = keyof typeof types
  const accept = props.acceptedTypes?.map((type) => types[type as TypeKey]).join(',')

  const width = props.width || 125
  const height = props.height || 125
  const defaultImg = props.blankImg || '/media/svg/files/blank-image.svg'

  return (
    <>
<Styles />
      <div
        className='image-wrapper'
        style={{
          backgroundImage: `url('${previewUrl || defaultImg}')`,
        }}
        onClick={() => {
          if (!props.disabled) inputRef.current?.click()
        }}
      >
        {previewUrl && (
          <div className='image-controls'>
            <span className='image-btn' title='Remove image' onClick={handleRemoveImage}>
              <i className='bi bi-x fs-2'></i>
            </span>
          </div>
        )}

        <input
          ref={inputRef}
          type='file'
          accept={accept || 'image/*'}
          className='image-input-hidden'
          onChange={handleImageChange}
          disabled={props.disabled}
        />
      </div>

      {sizeError && <div className='image-error'>{sizeError}</div>}
    </>
  )
}


